var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagerLeftGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 10,
    viewBox: "0 0 12.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pager-left_grey",
    transform: "translate(-496.75 -1471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-left",
    d: "M15.5,6l1.25,1.25L13,11l3.75,3.75L15.5,16l-5-5Z",
    transform: "translate(492.5 1465)",
    fill: "#bebebe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-left-2",
    "data-name": "arrow-left",
    d: "M15.5,6l1.25,1.25L13,11l3.75,3.75L15.5,16l-5-5Z",
    transform: "translate(486.25 1465)",
    fill: "#bebebe",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerLeftGrey);
export default __webpack_public_path__ + "static/media/pager-left_grey.cc10e0d30e0be4ffc3f341fe94628fb0.svg";
export { ForwardRef as ReactComponent };